import script from "./SecTeamGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./SecTeamGrid.vue?vue&type=script&setup=true&lang=js"

import "./SecTeamGrid.vue?vue&type=style&index=0&id=433b889c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-433b889c"]])

export default __exports__